import React from 'react';
import './text-input.css';

import SimpleInput from './SimpleInput';

class TextInput extends React.Component {
  constructor (props){
    super(props);
    this.state = {...props};
  }

  render(){
    const inputMask = this.props.inputMask ? this.props.inputMask : null;

    return(
      <div className="box-input">
          <div className="box-input--title">{this.props.title}</div>
          <div className="box-input--border">
            <div className="box-input--inner">
              <SimpleInput
                readOnly={this.props.readOnly}
                inputMask={inputMask}
                onChange={this.props.onChange}
                placeholder={this.props.placeholder}
                value={this.props.value}
                name={this.props.name}
                type={this.props.type}
              />
            </div>
          </div>
      </div>
    )
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/form/TextInput.js